import { createFileRoute, Outlet, redirect, isRedirect } from "@tanstack/react-router";
import { Sidebar } from "@/components/sidebar";
import { useAdminAuthGuard } from "@/hooks/use-admin-auth-guard";
import { refreshManager } from "@/lib/auth";
import { useAdminStore } from "@/store";

export const Route = createFileRoute("/_admin")({
  beforeLoad: async ({ context }) => {
    // Fast path: no session at all
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: "/login" });
    }
    // Role check (synchronous, no API needed)
    if (context.auth.user?.role !== "super_admin") {
      throw redirect({ to: "/access-denied" });
    }

    // Proactive refresh: ensure valid access token before rendering
    const state = useAdminStore.getState();
    if (!state.expiresAt || Date.now() >= state.expiresAt - 10_000) {
      try {
        const success = await refreshManager.refresh();
        if (!success) {
          throw redirect({ to: "/login" });
        }
      } catch (e) {
        if (isRedirect(e)) throw e;
        throw redirect({ to: "/login" });
      }
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  useAdminAuthGuard();
  return (
    <div className="flex h-dvh bg-slate-50">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <main className="flex-1 overflow-auto p-6 pt-14 md:pt-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
